import React from 'react'
import { Image, Popover } from 'antd'

const ImageWithHoverPreview = ({ url }: { url: string }) => {
  return (
    <Popover
      content={
        <Image
          src={url}
          preview={false}
          style={{ 
            width: '800px',
            height: '800px',
            objectFit: 'contain'
          }}
        />
      }
      trigger="hover"
      overlayStyle={{ zIndex: 10001 }}
      mouseEnterDelay={0.3}
      mouseLeaveDelay={0.1}
      placement="right"           // 默认在右侧显示
      autoAdjustOverflow={true}   // 自动调整防止溢出
      getPopupContainer={(triggerNode) => triggerNode.parentElement || document.body}
    >
      <Image
        style={{ cursor: 'pointer' }}
        width={100}
        src={url}
        preview={false}
      />
    </Popover>
  )
}

const getImage = (imgSrc: any) => {
  if (imgSrc) {
    return imgSrc.split('---').map((row: any, index: number) => (
      <ImageWithHoverPreview
        key={index.toString()}
        url={JSON.parse(row).url}
      />
    ))
  }
  return null
}

export default getImage